// extracted by mini-css-extract-plugin
export default {"pulse-green":"SelectableTimer_pulse-green__bHojF","pendingER":"SelectableTimer_pendingER__Vy26O","pulse-red":"SelectableTimer_pulse-red__xFOzA"};